import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { take } from 'rxjs/operators';
import { AuthenticationService } from "../../../authentication";
import { TidService } from "../../tid.service";

@Component({
  templateUrl: "./logout.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent implements OnInit {
  constructor(
    private authService: AuthenticationService,
    private tidService: TidService,
    private router: Router
  ) {}

  ngOnInit() {
    const token = this.tidService.getIdToken();
    this.authService.logout().pipe(take(1)).subscribe();
    if (typeof token === "string" && token.length > 0) {
      this.tidService.logoutWithTid();
    } else {
      this.router.navigateByUrl("/login");
    }
  }
}
